import {
  AdvancedMarker,
  ControlPosition,
  Map,
  MapControl,
} from "@vis.gl/react-google-maps";
import AnyReactComponent from "components/AnyReactComponent/AnyReactComponent";
import { CarDataType, ExperiencesDataType, StayDataType } from "data/types";
import { FC } from "react";
import { environment } from "../environment/environment";
import { useNavigate } from "react-router-dom";

interface MapContainerProps {
  currentHoverID: string | number;
  services: any[];
  listingType: "car" | "experiences" | "stay";
  centerPosition?: { latitude: number; longitude: number };
  userLocation?: { latitude: number; longitude: number };
}

const MapContainer: FC<MapContainerProps> = ({
  currentHoverID = -1,
  services,
  listingType,
  centerPosition,
  userLocation,
}) => {
  const navigate = useNavigate();
  if (!services) return null
  if (services?.length === 0) return null
  return (
    <>
      {/* BELLOW IS MY GOOGLE API KEY -- PLEASE DELETE AND TYPE YOUR API KEY */}
      <Map
        style={{
          width: "100%",
          height: "100%",
        }}
        defaultZoom={8}
        defaultCenter={
          userLocation
            ? { lat: userLocation.latitude, lng: userLocation.longitude }
            : centerPosition
            ? { lat: centerPosition.latitude, lng: centerPosition.longitude }
            : services[0].details.location.coordinates
        }
        center={
          currentHoverID !== -1
            ? services.find((item) => item.id === currentHoverID)?.details.location.coordinates
            : undefined
        }
        gestureHandling={"greedy"}
        mapId={environment.googleMapsApiKey}
      >
        <MapControl position={ControlPosition.TOP_CENTER}>
          {/*<div className="mt-5 py-2 px-4 bg-neutral-100 dark:bg-neutral-900 shadow-xl z-10 rounded-2xl min-w-max">*/}
          {/*  <Checkbox*/}
          {/*    className="text-xs xl:text-sm text-neutral-800"*/}
          {/*    name="search_as_i_move"*/}
          {/*    label="Search as I move the map"*/}
          {/*  />*/}
          {/*</div>*/}
        </MapControl>
        {services.map((item) => (
          <AdvancedMarker
            key={item.id}
            position={item.details.location.coordinates}
            clickable
            onClick={() => navigate(`/service-detail/${item.id}`)}
          >
            <AnyReactComponent
              isSelected={currentHoverID === item.id}
              key={item.id}
              lat={item.details.location.coordinates.lat}
              lng={item.details.location.coordinates.lng}
              car={listingType === "car" ? (item as CarDataType) : undefined}
              experiences={
                listingType === "experiences"
                  ? (item as ExperiencesDataType)
                  : undefined
              }
              listing={
                listingType === "stay" ? (item as StayDataType) : undefined
              }
            />
          </AdvancedMarker>
        ))}

        {userLocation && (
          <AdvancedMarker
            position={{ lat: userLocation.latitude, lng: userLocation.longitude }}
          >
            <div className="w-6 h-6 rounded-full bg-red-600 border-2 border-white shadow-lg"></div>
          </AdvancedMarker>
        )}
      </Map>
    </>
  );
};

export default MapContainer;
